module.exports = __webpack_public_path__ + "img/logo.68a4f462.svg";